import { render, staticRenderFns } from "./classe-toxicologica.vue?vue&type=template&id=5a0d181e&"
import script from "./classe-toxicologica.vue?vue&type=script&lang=js&"
export * from "./classe-toxicologica.vue?vue&type=script&lang=js&"
import style0 from "./classe-toxicologica.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports